import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { propTypes } from '../../util/types';
import logoNewImage from '../../assets/images/logo_new.png';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './GettingPaidPage.module.css';

import { Page } from '../../components';
import FallbackPage, { fallbackSections } from './FallbackPage';
import { ASSET_NAME } from './GettingPaidPage.duck';
import { camelize } from '../../util/string';
import { getMetadata } from '../PageBuilder/PageBuilder';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import gettingPaidFooter from '../../assets/images/gettingPaidFooter.png';

export const GettingPaidPageComponent = props => {
  const { pageAssetsData } = props;
  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');

  return (
    <Page {...pageMetaProps} scrollingDisabled={props.scrollingDisabled}>
      <div 
        className={css.GettingPaidPage}
        style={{
          backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        }}
      >
        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            backgroundImage: `url(${require('../../assets/images/gettingPaid.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            <img src={logoNewImage} alt="Farmiez Logo" className={css.faqLogo} />
            <h1 className={css.heroTitle}>Getting Paid</h1>
          </div>
        </div>

        <div className={css.gettingPaidContentWrap}>
          <div className={css.content}>
            <p className={css.intro}>
              At Farmiez Marketplace, we keep payments simple, secure, and fast — so you can spend more time 
              collecting fresh eggs, tending the garden, or stocking your farm stand.
            </p>
            <div className={css.textBlock}>
              <p>
                We use <strong>Stripe</strong>, one of the world's most trusted payment processors, 
                to handle all transactions between you and your customers.
              </p>

              <h3>How It Works</h3>
              <p>🐓 <strong>Customer Orders</strong> → Shoppers pay securely through Farmiez using Stripe.</p>
              <p>💰 <strong>You Get Paid</strong> → Stripe sends the funds directly to your connected bank account.</p>

              <h3>Payout Timing ⏱️</h3>
              <p>
                Once an order is completed, payouts typically arrive in your bank account within 
                <strong> 2–3 business days</strong>.  
                You can check your exact payout schedule in your Stripe Dashboard anytime.
              </p>

              <h3>Fees 💵</h3>
              <ul>
                <li><strong>Farmiez Subscription Fee</strong> — based on your plan (Starter, Grower, or Plus).</li>
                <li><strong>Stripe Processing Fee</strong> — standard Stripe rates apply (currently 2.9% + $0.30 per transaction in the U.S.).</li>
              </ul>
              <p>We believe in keeping it transparent — no hidden fees, ever.</p>
              <div className={css.ctaWrapper}>
                <a
                  href="https://dashboard.stripe.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.customBtn}
                >
                  Go to My Stripe Dashboard
                </a>
              </div>
            </div>
          </div>

          <img src={gettingPaidFooter} alt="img" className={css.footerImg}/>
        </div>
        
        <FooterContainer />
      </div>
    </Page>
  );
};

GettingPaidPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData } = state.hostedAssets || {};

  return {
    pageAssetsData,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const GettingPaidPage = compose(connect(mapStateToProps))(GettingPaidPageComponent);

export default GettingPaidPage;
